import Raven from 'raven-js';
import environment, { getEnvString } from '../../../../services/environment';
import { inIframe, packageVersion, pageLang } from '../../services/app-storage';
import getCountryCode from '../../services/country-code';
import { addEvent } from '../../services/dom';

export namespace Sentry {

    let tags: any;

    export function configure(): void {
        Raven.config('https://1aaab6611a6e40f89a064434683ec42b@app.getsentry.com/83219', {
            release: packageVersion,
            whitelistUrls: [/get-e\.com/],
            environment: getEnvString(environment),
            autoBreadcrumbs: {
                xhr: false
            }
        }).install();

        addEvent('unhandledrejection', window, e => {
            Raven.captureException((e as any as { detail: { reason: Error } }).detail.reason);
        });

        tags = {
            inFrame: inIframe,
            noStorage: !Modernizr.localstorage || !Modernizr.sessionstorage,
            language: pageLang
        };

        Raven.setTagsContext(tags);

        getCountryCode().then(code => {
            tags.country = code;
            Raven.setTagsContext(tags);
        }, () => {
            // Unable to get country
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/bundle/sentry.ts